import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable jsx-a11y/label-has-associated-control */

/* eslint-disable jsx-a11y/no-autofocus */
import "./scss/styles.scss";
import React from "react";
import { useIntl } from "react-intl";
import { settingsMessages } from "@temp/intl";
import AlertLogin from "../../../../components/AlertLogin";
export var NotificationControlButton = function NotificationControlButton(_ref) {
  var data = _ref.data;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showAlertLogin = _React$useState2[0],
      setShowAlertLogin = _React$useState2[1];

  var intl = useIntl();
  return React.createElement("div", {
    className: "notificationControlButtonContainer"
  }, React.createElement("button", {
    onClick: function onClick() {
      setShowAlertLogin(true);
    },
    className: "notificationControlButton"
  }, intl.formatMessage(settingsMessages.doNotWantToReceiveNotifications)), showAlertLogin && React.createElement(AlertLogin, {
    hideModal: function hideModal() {
      return setShowAlertLogin(false);
    },
    data: data,
    useCurrentTrade: true
  }));
};
NotificationControlButton.displayName = "NotificationControlButton";